import { render, staticRenderFns } from "./minimalize-outlined.vue?vue&type=template&id=19bf1934&scoped=true&"
var script = {}
import style0 from "./minimalize-outlined.vue?vue&type=style&index=0&id=19bf1934&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bf1934",
  null
  
)

export default component.exports